var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trivia-container"},[_vm._m(0),_c('Title',{attrs:{"title":this.$store.state.currentCategory}}),_c('router-link',{attrs:{"to":"/trivia/questions"}},[_c('Button',{staticClass:"button",attrs:{"color":"orange","buttonText":"Start"}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('h3',[_vm._v(":20")])])
}]

export { render, staticRenderFns }